// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { green, green25, green50, green75 } from '../../constants/colors';
import DefaultLogSizeSelectorWarningModal from './DefaultLogSizeSelectorWarningModal';
import DefaultLogSizeSelectorEditButton from './DefaultLogSizeSelectorEditButton';
// css
import '../../styles/components/sources/DefaultLogSizeSelector.scss';


class DefaultLogSizeSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locked: true,
      warningModalOpen: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleUnlock = this.handleUnlock.bind(this);
    this.handleConfirmUnlock = this.handleConfirmUnlock.bind(this);
    this.handleDismissWarningModal = this.handleDismissWarningModal.bind(this);
  }

  handleChange(selectedOption) {
    const value = parseFloat(selectedOption.value);
    const { onChange } = this.props;

    this.setState({ locked: true });
    onChange(value);
  }

  handleUnlock() {
    this.setState({ locked: false, warningModalOpen: false });
  }

  handleConfirmUnlock() {
    this.setState({ warningModalOpen: true });
  }

  handleDismissWarningModal() {
    this.setState({ warningModalOpen: false });
  }

  render() {
    const { value } = this.props;
    const { locked, warningModalOpen } = this.state;
    const options = [
      { value: 0.8, label: 'Low (-20%)' },
      { value: 1.0, label: 'Standard' },
      { value: 1.2, label: 'High (+20%)' }
    ];

    const selectTheme = (theme) => ({
      ...theme,
      colors: {
        ...theme.colors,
        primary: green,
        primary25: green25,
        primary50: green50,
        primary75: green75
      }
    });

    return (
      <div className='DefaultLogSizeSelector SourcesHeaderInput'>
        <span className='DefaultLogSizeSelector__label SourcesHeaderInput__label'>
          Default Log Size:
        </span>
        <span className='DefaultLogSizeSelector__input SourcesHeaderInput__input'>
          <Select
            options={options}
            onChange={this.handleChange}
            value={options.find(option => option.value === value)}
            isDisabled={locked}
            isSearchable={false}
            className='DefaultLogSizeSelector__select'
            blurInputOnSelect
            theme={selectTheme}
          />
          <DefaultLogSizeSelectorEditButton
            visible={locked}
            onClick={this.handleConfirmUnlock}
          />
        </span>
        <DefaultLogSizeSelectorWarningModal
          open={warningModalOpen}
          onSubmit={this.handleUnlock}
          onDismiss={this.handleDismissWarningModal}
        />
      </div>
    );
  }
}

DefaultLogSizeSelector.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default DefaultLogSizeSelector;



// WEBPACK FOOTER //
// ./src/components/sources/DefaultLogSizeSelector.js